import { FirestoreDetection } from '@trace/types';
import { firestore } from 'firebase/app';
import { useEffect, useRef, useState, useContext } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';
import getOnboardingProgress, { OnboardingProgress } from '../../utils/getOnboardingProgress';

const useOnboarding = (): OnboardingProgress => {
  const refInterval = useRef(0);
  const {
    data: { appId },
  } = useContext(AuthContextTrace);
  const [detection] = useDocumentData<FirestoreDetection>(firestore().doc(`/detections/${appId}`));
  const firstSeen = detection && detection.firstSeen;
  const [onboarding, setOnboarding] = useState(getOnboardingProgress(firstSeen));

  useEffect(() => {
    if (firstSeen) {
      refInterval.current = window.setInterval(() => {
        const newOnboarding = getOnboardingProgress(firstSeen);

        setOnboarding(newOnboarding);

        if (newOnboarding.progress >= 1) {
          window.clearInterval(refInterval.current);
        }
      }, 1000);
    }

    return () => {
      window.clearInterval(refInterval.current);
    };
  }, [firstSeen]);

  return onboarding;
};

export default useOnboarding;
